const VERTICAL_EMBED_TYPE = "wix-draft-plugin-vertical-embed";
export {
  VERTICAL_EMBED_TYPE
};
//# sourceMappingURL=types.js.map
